import { ASAP, SCHEDULE } from "../constants/deliveryType";
import orderBy from 'lodash/orderBy';
import uniqBy from "lodash/uniqBy";
import getHighestValueAttribute from "./getHighestValueAttribute";
import { GANJAGODDESS } from "../constants/website";
import sortBy from 'lodash/sortBy';

export const getHighlightedWord = (highlightedArray, query) => {
  const highlightedBrand =
    highlightedArray?.brands?.find(
      item => item?.fullyHighlighted === true || item?.matchLevel === 'full' || item?.matchLevel === 'partial'
    ) || {};
  const highlightedCategories =
    highlightedArray?.full_shop_categories?.find(
      item => item?.fullyHighlighted === true || item?.matchLevel === 'full' || item?.matchLevel === 'partial'
    ) || {};
  const highlightedName = highlightedArray?.name || {};
  const highlightedStrain = highlightedArray?.strain || {};
  const highlightedFacet = [highlightedName, highlightedBrand, highlightedCategories, highlightedStrain].filter(
    item => item?.fullyHighlighted === true || item?.matchLevel === 'full' || item?.matchLevel === 'partial'
  );
  const highlightedTextByFullyHighlighted = highlightedFacet?.find(item => item?.fullyHighlighted === true) || '';
  const highlightedTextByMatchLevelFull = highlightedFacet?.find(item => item?.matchLevel === 'full') || '';
  const highlightedTextByMatchLevelPartial = highlightedFacet?.find(item => item?.matchLevel === 'partial') || '';
  const highlightedObject =
    highlightedTextByFullyHighlighted || highlightedTextByMatchLevelFull || highlightedTextByMatchLevelPartial || '';
  const highlightedText = highlightedObject ? parseHighlightedValue(highlightedObject?.value || '')?.join(' ')?.replace(/&amp;/g, '&')?.replace(/&#39;/g, "'") : '';
  const typoTolerance = highlightedText?.toLowerCase()?.trim() !== query?.toLowerCase()?.trim();
  const highlightedTextLowerCase = highlightedText?.toLowerCase()?.trim();
  return { typoTolerance, highlightedText, highlightedTextLowerCase }
}

const parseHighlightedValue = str =>
  str?.match(/<mark>(.*?)<\/mark>/g)?.map(function (val) {
    return val.replace(/<\/?mark>/g, '');
  });

const isGG = process.env.NEXT_PUBLIC_APP === GANJAGODDESS;

export const groupProductByCategroies = ({ hits, categoryRefinment, locationId, zoneId, currentTab, searchQuery, selectedPriceSort, bringItProducts, fullCategoryList }) => {

  const { highlightedText, highlightedTextLowerCase } = getHighlightedWord(hits?.[0]?._highlightResult || {}, searchQuery);
  const groupByCategory = hits.reduce((group, product) => {
    const { full_shop_categories: categories } = product;
    categories.forEach(item => {
      if (!categoryRefinment.length || categoryRefinment?.[0]?.refinements?.find(refine => refine.value == item)) {
        group[item] = group[item] ? group[item] : [];
        group[item].push(modifedProduct(product, locationId, zoneId, currentTab, item, highlightedTextLowerCase))
      };
    })
    return group;
  }, []);

  let groupCtegories = {};

  Object.keys(groupByCategory).forEach(item => {
    groupByCategory[item].forEach((pItem, index) => {
      if (index === 0) {
        groupCtegories[item] = {
          category_id: pItem?.groupCategoryName,
          category_name: pItem?.groupCategoryName,
          "_highlightResult": {
            "category_name": {
              "value": pItem?.groupCategoryName?.toLowerCase().trim()?.split(highlightedTextLowerCase).join(`<mark>${highlightedTextLowerCase}</mark>`)
            }
          },
          products: [],
          category_name_lower_case: pItem?.groupCategoryName?.toLowerCase()
        };
      }
      groupCtegories[item].products.push(pItem);
    });
  });
  groupCtegories = Object.values(groupCtegories);
  groupCtegories = orderBy(groupCtegories, ['category_name'], ['asc']);
  let newfullCategoryList = fullCategoryList.reduce((acc, curr) => {
    curr.name = curr?.name?.toLowerCase()
    acc.push(curr);
    let newValue = Object.assign({}, curr);
    newValue.name = newValue?.name?.substring(0, newValue?.name?.length - 1)?.toLowerCase();
    acc.push(newValue);
    return acc
  }, []);
  groupCtegories = sortBy(groupCtegories, function (element) {
    const rank = Object.fromEntries(
      newfullCategoryList.map(({ name }, index) => [name, index])
    );
    return rank[element?.category_name_lower_case];
  });

  let bringItIds = bringItProducts?.products?.map(item => {
    return item?.product_details_id;
  })
  let searchBringItProducts = {
    category_id: 'Bring It Again',
    category_name: 'Bring It Again',
    "_highlightResult": {
      "category_name": {
        "value": 'Bring It Again'
      }
    },
    products: hits
  }

  if (searchBringItProducts?.products.length && !categoryRefinment.length) {
    let modifiedBringItProducts = searchBringItProducts?.products?.reduce((acc, product) => {
      if (bringItIds?.includes(product?.product_details_id)) {
        acc.push(modifedProduct(product, locationId, zoneId, currentTab, 'Bring It Again', highlightedTextLowerCase));
      }
      return acc;
    }, [])
    if (modifiedBringItProducts?.length) {
      searchBringItProducts.products = modifiedBringItProducts;
      groupCtegories = [
        searchBringItProducts,
        ...groupCtegories
      ]
    }

  }
  let finalCategories = groupCtegories.reduce((acc, curr) => {
    let newProducts = curr?.products;
    if ((selectedPriceSort == '' && !isGG) || selectedPriceSort == 'deals') {
      newProducts = orderBy(curr?.products, ['is_sold_out', 'is_deal_available'],
        ['asc', 'desc']);
    }
    else if (selectedPriceSort == 'price-high-to-low') {
      newProducts = orderBy(curr?.products, ['is_sold_out', 'price'],
        ['asc', 'desc']);
    }
    else if (selectedPriceSort == 'price-low-to-high') {
      newProducts = orderBy(curr?.products, ['is_sold_out', 'price'],
        ['asc', 'asc']);
    }
    else if (selectedPriceSort == 'thc-high-to-low') {
      newProducts = orderBy(curr?.products, ['is_sold_out', 'thcValue'],
        ['asc', 'desc']);
    }
    else if (selectedPriceSort == 'thc-low-to-high') {
      newProducts = orderBy(curr?.products, ['is_sold_out', 'thcValue'],
        ['asc', 'asc']);
    }
    else {
      newProducts = orderBy(curr?.products, ['is_sold_out'],
        ['asc']);
    }
    acc.push({
      ...curr,
      products: newProducts
    })
    return acc;
  }, [])
  return finalCategories;
}

const modifedProduct = (product, locationId, zoneId, currentTab, category, highlightedTextLowerCase) => {
  let thc = getHighestValueAttribute(product?.attributeContent, product?.unitValue, product?.unitType);
  thc = thc?.[0]?.type != 2 ? Number(thc?.[0]?.value) : Number(thc?.[0]?.value?.split(",")?.pop());
  let available_quantity = product?.location_specific_details?.[locationId]?.product_qty?.asap?.find(item => item?.zoneId === zoneId) || null;
  available_quantity = available_quantity?.quantity ? available_quantity?.quantity : 0;

  return {
    ...product,
    asap: product?.location_specific_details?.[locationId]?.delivery?.includes(zoneId) ? 1 : 0,
    available_quantity: available_quantity,
    brand_names: product?.brands || [],
    is_sold_out: currentTab === ASAP ? 0 : currentTab === SCHEDULE &&
      product?.location_specific_details?.[locationId]?.product_qty?.schedule > 0 ? 0 : 1,
    price: Number(product?.domain_location_specific_details?.[locationId]?.price),
    price_without_deal: Number(product?.domain_location_specific_details?.[locationId]?.price_without_deal),
    product_name: product?.custom_name || product?.name,
    schedule: product?.location_specific_details?.[locationId]?.delivery?.includes(SCHEDULE) ? 1 : 0,
    groupCategoryName: category,
    product_attributes: product?.attributeContent,
    thcValue: thc,
    product_unit: product?.unitType,
    bulk_prices: product?.bulk_prices?.length ? product?.bulk_prices : null,
    product_strain_type_name: product?.strain,
    is_deal_available: product?.domain_location_specific_details?.[locationId]?.is_deal_available || 0,
    product_id: product?.product_id || product?.product_details_id,
    product_currency: product?.product_currency || '$',
    _highlightResult: {
      ...product._highlightResult,
      "custom_brand": {
        "value": product?._highlightResult?.brands?.[0]?.value
      }
    }
  }
}

export const getBrands = ({ hits, searchQuery }) => {

  const { highlightedTextLowerCase } = getHighlightedWord(hits?.[0]?._highlightResult || {}, searchQuery);
  const unquieBrands = uniqBy(hits, 'brands[0]');

  let brandBySearch = unquieBrands?.reduce((acc, curr) => {

    if (curr?.brands?.[0]?.toLowerCase()?.trim().search(searchQuery.toLowerCase()?.trim()) == 0 ||
      (curr?.brands?.[0]?.split(' ')?.filter(p => p?.toLowerCase()?.trim()?.search(searchQuery.toLowerCase()?.trim()) == 0))?.length) {
      curr._highlightResult =
      {
        ...curr._highlightResult,
        "custom_brand": {
          "value": curr?._highlightResult?.brands?.[0]?.value
        }
      }
      acc.push(curr);
    }
    return acc;
  }, [])

  return brandBySearch;
}